import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import WifiIcon from '@mui/icons-material/Wifi';


import MainMenu from '../components/home/MainMenu';
import OSMLandingPage from './OSMLandingPage';


import Icon from '@mdi/react';
import {
    mdiLanConnect,
} from '@mdi/js';

import { userSelector, logout, setNeedFirstLoad, googleMapKeySelector, googleMapDevKeySelector } from '../features/user/UserSlice';

import {
    firstLoad, assetsSelector,
    assetSocketConnect, assetSocketDisconnect,
    unload, /*assetListSelector, assetBatchRun,*/
} from '../features/assets/assetsSlice';
import { defaultEventsLoad, setViewType } from '../features/events/eventsSlice';
import { getPlaces } from '../features/places/placesApi';
import { setlayoutLiveTracking, liveTrackinglayoutSelector } from '../features/layout/layoutSlice';
import { setNeedBounding, showMapToolBarSelector, mapServiceSelector, changeMapService } from '../features/map/mapSlice';

import MapToolbar from '../components/map/MapToolbar';
import GoogleMapInstance from '../components/map/google/GoogleMapInstance';
import SecuredRoutes from '../components/SecuredRoutes';
import AdminMainModal from '../components/admin/AdminMainModal';
import DieselPricesModal from '../components/fuel/DieselPricesModal';
import { fetchAllDieselPrices } from '../features/dieselprice/dieselPriceApi';

const drawerWidth = 240;
const libraries = ['geometry', 'places', 'drawing'];

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    maxHeight: '100vh',
    overflow: 'auto'
}));

const AppBarStyled = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));



const HomePage = () => {
    //console.log("Home render", window.location.origin);

    const dimentions = useSelector(liveTrackinglayoutSelector);

    const dispatch = useDispatch();
    //const assetList = useSelector(assetListSelector);
    const showMapToolBar = useSelector(showMapToolBarSelector);
    const thisUser = useSelector(userSelector);
    const { sockHost, isAdmin } = thisUser;
    const googleMapKey = useSelector(googleMapKeySelector);
    const googleMapDevKey = useSelector(googleMapDevKeySelector);
    const mapService = useSelector(mapServiceSelector);
    const needFirstLoad = useSelector(state => state.user.needFirstLoad);
    const { loaded, socketLive } = useSelector(assetsSelector);
    const onLogOut = () => {
        dispatch(assetSocketDisconnect(sockHost));
        dispatch(unload());
        dispatch(logout());

    };
    const [open, setOpen] = useState(false);

    const liveTrackingLayoutUpdate = useCallback(
        () => {
            const liveTrackingLayoutPayload = {
                sidebarWidthratio: 0.25,
                minFooter: 80,
            };
            dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
        },
        [dispatch],
    )

    useEffect(() => {
        window.addEventListener('resize', liveTrackingLayoutUpdate);
        return () => window.removeEventListener('resize', liveTrackingLayoutUpdate);
    }, [liveTrackingLayoutUpdate])


    useEffect(() => {

        if (needFirstLoad) {
            //console.log("Home page loaded");
            dispatch(assetSocketDisconnect(sockHost));
            dispatch(unload());
            dispatch(firstLoad());
            dispatch(getPlaces());
            dispatch(setViewType('default'));
            dispatch(defaultEventsLoad({ hours: 2 }));
            //console.log("Set app layout dimentions");
            liveTrackingLayoutUpdate();
            dispatch(fetchAllDieselPrices());
            dispatch(setNeedFirstLoad(false));
            if (window.location.origin === 'http://localhost:3000') {
                //console.log("Changing map to osm");
                dispatch(changeMapService('osm'));
            }

        }


    }, [dispatch, liveTrackingLayoutUpdate, needFirstLoad, sockHost])

    const sockConnect = useCallback(() => {
        if (socketLive) {
            return;
        }
        console.log('Connecting to socket with token:', thisUser.token, sockHost);
        dispatch(assetSocketConnect({
            host: sockHost,
            token: thisUser.token
        }));
    }, [dispatch, sockHost, socketLive, thisUser.token]);

    useEffect(() => {
        if (loaded && sockHost) {
            sockConnect();
        }
    }, [loaded, sockHost, dispatch, sockConnect]);

    useEffect(() => {
        dispatch(setNeedBounding(true));
    }, [loaded, dispatch]);

    const handleDrawerOpen = () => {
        setOpen(true);
        toggleDrawer('left', true)
    };

    const handleDrawerClose = () => {
        setOpen(false);
        toggleDrawer('left', false)
    };

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [adminOpen, setadminOpen] = useState(false);
    const [dieselModalOpen, setDieselModalOpen] = useState(false);
    const handleAdminClose = () => {
        setadminOpen(false);
    }
    const handleDieselModalClose = () => {
        setDieselModalOpen(false);
    }


    return (
        <Root>
            <CssBaseline />
            <AppBarStyled position="fixed" open={open}>
                <Toolbar variant="dense" sx={{ bgcolor: socketLive ? 'inherit' : 'error.main' }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{
                            marginRight: 4.5,
                            ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
                        iLogistek 3.0
                    </Typography>
                    <Button
                        onClick={() => setDieselModalOpen(true)}
                        sx={{
                            mr: 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                            color: 'white',
                            borderColor: 'rgba(255,255,255,0.45)',
                            '&:hover': { borderColor: 'rgba(255,255,255,0.8)' },
                        }}
                        variant="outlined"
                        size="small"
                    >
                        Diesel Price
                    </Button>
                    {
                        socketLive ?
                            <IconButton color="inherit" onClick={() => { }} size="large">
                                <WifiIcon />
                            </IconButton>
                            :
                            <Button
                                startIcon={
                                    <Icon
                                        path={mdiLanConnect}
                                        title="Refresh"
                                        size={0.8}
                                        color="White"
                                    />
                                }
                                onClick={() => sockConnect()}
                            >
                                <span style={{ color: 'White' }}>
                                    Connect
                                </span>
                            </Button>
                    }
                    <IconButton onClick={onLogOut} color="inherit" edge="end" size="large">
                        <ExitToAppIcon />
                    </IconButton>
                </Toolbar>
            </AppBarStyled>
            <Drawer
                variant="temporary"
                anchor="left"
                open={open}
                onClose={handleDrawerClose}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <MainMenu
                    handleDrawerClose={handleDrawerClose}
                    setadminOpen={setadminOpen}
                    onLogOut={onLogOut}
                    thisUser={thisUser}
                />
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
                <Toolbar variant="dense" />
                {loaded ?
                    mapService === 'osm' ?
                        <OSMLandingPage
                            showMapToolBar={showMapToolBar}
                            isAdmin={isAdmin}
                            adminOpen={adminOpen}
                            handleAdminClose={handleAdminClose}
                            dimentions={dimentions}
                        />
                        :
                        <Fragment>
                            <GoogleMapInstance libraries={libraries} googleMapKey={googleMapKey} googleMapDevKey={googleMapDevKey} />
                            <SecuredRoutes />
                            {
                                showMapToolBar &&
                                <div style={dimentions.rightToolbar}>
                                    <MapToolbar />
                                </div>
                            }
                            {
                                isAdmin && <AdminMainModal adminOpen={adminOpen} handleAdminClose={handleAdminClose} />
                            }
                        </Fragment>
                    :
                    <Box>
                        <LinearProgress />
                    </Box>
                }
                <ToastContainer autoClose={3000} />
            </Box>
            <DieselPricesModal open={dieselModalOpen} onClose={handleDieselModalClose} />
        </Root>
    );
}

export default React.memo(HomePage);


/*

<Fragment >
                                <OpenstreetmapInstance />
                                <SecuredRoutes style={{ zIndex: 401 }} />
                                {
                                    showMapToolBar &&
                                    <div style={dimentions.rightToolbar}>
                                        <MapToolbar style={{ zIndex: 401 }} />
                                    </div>
                                }
                                {
                                    isAdmin && <AdminMainModal adminOpen={adminOpen} handleAdminClose={handleAdminClose} style={{ zIndex: 401 }} />
                                }
                            </Fragment>
*/
/*


                                <div style={{ position: 'fixed', left: '200px' }}>
                                    <Grid
                                        container
                                        spacing={0}
                                        direction="column"
                                        alignItems="center"
                                        justify="center"
                                        style={{ minHeight: '80vh' }}
                                    >
                                        <Grid item xs={3}>
                                            <Typography variant="h3">
                                                You need an invitation.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            */
